/**
 * Toast Store (Zustand)
 *
 * Lightweight global toast notification system.
 * Used for rate limit countdowns, errors, and confirmations.
 */

import { create } from 'zustand';

export interface ToastMessage {
  id: string;
  message: string;
  type: 'info' | 'success' | 'error' | 'warning';
  /** Optional countdown seconds for rate-limit toasts */
  countdown?: number;
}

interface ToastState {
  toasts: ToastMessage[];
  addToast(toast: Omit<ToastMessage, 'id'>): void;
  removeToast(id: string): void;
}

function makeId(): string {
  return `toast-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`;
}

export const useToastStore = create<ToastState>((set) => ({
  toasts: [],

  addToast: (toast) => {
    const id = makeId();
    set((s) => ({ toasts: [...s.toasts, { ...toast, id }] }));
    // Auto-dismiss after 5 seconds (unless it has a countdown)
    setTimeout(() => {
      set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) }));
    }, 5000);
  },

  removeToast: (id) => {
    set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) }));
  },
}));
